import React from 'react';

const style ={
    background: "linear-gradient(270deg, #FFAD00 0%, #FFD273 18.7%, #E19A04 42.13%, #FACF75 68.82%, #E7A725 85.94%, #FFAD00 100%)",
    boxShadow: "0px 8px 25px rgb(39 64 101 / 10%)",
    borderRadius: "35px",
    height: "40px",
    width: "25%",
    textTransform: "capitalize",
    fontWeight: "bold"
}

const Button = ({text}) => {
    return (
        <>
            <button style={style}>{text}</button>
        </>
    );
};

export default Button;